import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { styledComponent } from '@ecp/common/src/components/swiper/component/SwiperController';

const StyledLabel = styled(FlexBox)`
  color: ${({ isWhite }) => (isWhite ? '#ffffff' : '#141415')};
  padding-left: 14px;
  font-size: ${({ size }) => (size ? size : boTheme.font.size.error)};
`;

const LabelComponent = (props) => {
  const { current, total, isWhite } = props;

  return (
    <StyledLabel isWhite={isWhite}>
      <styledComponent.StyledCurrentLabel>{current}</styledComponent.StyledCurrentLabel>
      <span>/{total}</span>
    </StyledLabel>
  );
};

LabelComponent.displayName = 'LabelComponent';

LabelComponent.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
  isWhite: PropTypes.bool,
};

// label
const StyledSwiperLabel = styled(FlexBox)`
  font-size: ${({ size }) => (size ? size : boTheme.font.size.small)};
  color: ${boTheme.color.sub1};
  height: 30px;
  position: absolute;
  bottom: ${({ bottom }) => (bottom ? bottom : '0px')};
  left: ${({ left }) => (left ? left : '50%')};
  transform: ${({ left }) => (left ? 'unset' : 'translate(-50%,0)')};
  z-index: 1;
`;

const StyledCurrentLabel = styled.span`
  font-weight: ${boTheme.font.weight.bold};
`;

export const SwiperLabel = (props) => {
  const { current, total, ...otherProps } = props;

  return (
    <StyledSwiperLabel {...otherProps}>
      <StyledCurrentLabel>{current}</StyledCurrentLabel>
      <span>/{total}</span>
    </StyledSwiperLabel>
  );
};

SwiperLabel.displayName = 'SwiperLabel';

SwiperLabel.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
};

export const SwiperOuterLabel = (props) => <SwiperLabel bottom="-30px" {...props} />;

SwiperOuterLabel.displayName = 'SwiperOuterLabel';

SwiperOuterLabel.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
};
